import store from '^/mainStore'

export default {
    name: 'order-my-remote',
    path: '/order-my-remote',
    components: {
        app: () => import(/* webpackChunkName: "apps/OrderRemoteControl" */ '~/OrderRemoteControl/App.vue'),
    },
    redirect: '/order-my-remote/auth',
    children: [
        {
            name: 'auth',
            path: '/order-my-remote/auth',
            components: {
                main: () => import(/* webpackChunkName: "apps/OrderRemoteControl" */ '~/OrderRemoteControl/AuthPage.vue'),
            },

        },
        {
            name: 'confirm-address',
            path: '/order-my-remote/confirm-address',
            components: {
                main: () => import(/* webpackChunkName: "apps/OrderRemoteControl" */ '~/OrderRemoteControl/ConfirmAddressPage.vue'),
            },
            async beforeEnter (to, from, next) {
                try {
                    const hasPermission = await store.getters['orderRemote/hasPermission']
                    if (hasPermission) {
                        next()
                    } else {
                        next({
                            name: 'auth', // back to safety route //
                            query: { redirectFrom: to.fullPath }
                        })
                    }
                } catch (error) {
                    next({
                        name: 'auth', // back to safety route //
                        query: { redirectFrom: to.fullPath }
                    })
                }
            }
        },

        {
            name: 'previous-orders',
            path: '/order-my-remote/previous-orders',
            components: {
                main: () => import(/* webpackChunkName: "apps/OrderRemoteControl" */ '~/OrderRemoteControl/PreviousOrdersPage.vue'),
            },
            async beforeEnter (to, from, next) {
                try {
                    const hasPermission = await store.getters['orderRemote/hasPermission']
                    if (hasPermission) {
                        next()
                    } else {
                        next({
                            name: 'auth', // back to safety route //
                            query: { redirectFrom: to.fullPath }
                        })
                    }
                } catch (error) {
                    next({
                        name: 'auth', // back to safety route //
                        query: { redirectFrom: to.fullPath }
                    })
                }
            }

        },
        {
            name: 'remote-selection',
            path: '/order-my-remote/selection',
            components: {
                main: () => import(/* webpackChunkName: "apps/OrderRemoteControl" */ '~/OrderRemoteControl/RemoteSelectionPage.vue'),
            },
            async beforeEnter (to, from, next) {
                try {
                    const hasPermission = await store.getters['orderRemote/hasPermission']
                    if (hasPermission) {
                        next()
                    } else {
                        next({
                            name: 'auth', // back to safety route //
                            query: { redirectFrom: to.fullPath }
                        })
                    }
                } catch (error) {
                    next({
                        name: 'auth', // back to safety route //
                        query: { redirectFrom: to.fullPath }
                    })
                }
            }

        },

        {
            name: 'confirm-email',
            path: '/order-my-remote/confirm-email',
            components: {
                main: () => import(/* webpackChunkName: "apps/OrderRemoteControl" */ '~/OrderRemoteControl/ConfirmEmailPage.vue'),
            },
            async beforeEnter (to, from, next) {
                try {
                    const hasPermission = await store.getters['orderRemote/hasPermission']
                    if (hasPermission) {
                        next()
                    } else {
                        next({
                            name: 'auth', // back to safety route //
                            query: { redirectFrom: to.fullPath }
                        })
                    }
                } catch (error) {
                    next({
                        name: 'auth', // back to safety route //
                        query: { redirectFrom: to.fullPath }
                    })
                }
            }
        },

        {
            name: 'confirmation',
            path: '/order-my-remote/confirmation',
            components: {
                main: () => import(/* webpackChunkName: "apps/OrderRemoteControl" */ '~/OrderRemoteControl/ConfirmationPage.vue'),
            },
            async beforeEnter (to, from, next) {
                try {
                    const hasPermission = await store.getters['orderRemote/hasPermission']
                    if (hasPermission) {
                        next()
                    } else {
                        next({
                            name: 'auth', // back to safety route //
                            query: { redirectFrom: to.fullPath }
                        })
                    }
                } catch (error) {
                    next({
                        name: 'auth', // back to safety route //
                        query: { redirectFrom: to.fullPath }
                    })
                }
            }

        },
    ]

}
